import React from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';
import { ReactComponent as ChevronDown } from '../../assets/img/chevron-down.svg';
import { ReactComponent as ChevronDownSmall } from '../../assets/img/chevron-down-small.svg';

const Accordion = ({ items, chevronClasses = '', variant = 'default' }) => (
  <RadixAccordion.Root className='' type='multiple' collapsible='true'>
    {items &&
      items.map((item, i) => {
        return (
          <RadixAccordion.Item className='' value={`item-${i}`} key={`${i}`}>
            <AccordionTrigger chevronClasses={chevronClasses} variant={variant}>
              <span className='text-base text-blue-500 w-full text-start'>
                {item.title}
              </span>
            </AccordionTrigger>
            <AccordionContent>{item.content}</AccordionContent>
          </RadixAccordion.Item>
        );
      })}
  </RadixAccordion.Root>
);

const AccordionTrigger = React.forwardRef(
  ({ children, className: _cn, chevronClasses, variant, ...props }, forwardedRef) => (
    <RadixAccordion.Header className='py-1'>
      <RadixAccordion.Trigger
        className={`flex items-start  group w-full ${
          variant === 'default' && 'gap-2.5'
        } ${variant === 'small' && 'gap-[7px]'}`}
        {...props}
        ref={forwardedRef}
      >
        <div className={`text-blue-100 `}>
          {variant === 'default' && (
            <ChevronDown
              className={`group-data-[state=open]:rotate-180 -translate-y-px ${chevronClasses}`}
              aria-hidden
            />
          )}

          {variant === 'small' && (
            <ChevronDownSmall
              className={`group-data-[state=open]:rotate-180 translate-y-0.5 ${chevronClasses}`}
              aria-hidden
            />
          )}
        </div>
        {children}
      </RadixAccordion.Trigger>
    </RadixAccordion.Header>
  )
);

const AccordionContent = React.forwardRef(
  ({ children, className: _cn, ...props }, forwardedRef) => (
    <RadixAccordion.Content className='ml-5 pt-2.5 pb-5' {...props} ref={forwardedRef}>
      <div className='' data-component-name='Accordion'>
        {children}
      </div>
    </RadixAccordion.Content>
  )
);

export default Accordion;
